<div [@routerTransition]>
    <sub-header [title]="('AddStock' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="VendorDisplayProperty">{{ l('Vendor') }}</label>
                            <app-search-vendor (vendorEvent)="getVendor($event)" [vendorSelectedItem]="this.vendorSelectedItem"> </app-search-vendor>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="AddStock_PDate">{{ l('PDate') }}</label>

                            <abp-datetime-picker #AddStock_date="ngModel" [(ngModel)]="addStock.stockDate"
                                                 id="AddStock_date" name="AddStock_stockDate"
                                                 [bsConfig]="{ adaptivePosition: true }"></abp-datetime-picker>

                            <validation-messages [formCtrl]="AddStock_date"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="StockAdjustmentTypes">{{ l('Type') }}</label>
                            <select name="addStock.stockAdjustmentTypeId"
                                            [(ngModel)]="addStock.stockAdjustmentTypeId"
                                            class="form-select"
                                            >
                                        <option value="">{{ l('SelectStockAdjustmentType') }}</option>

                                        <option *ngFor="let item of allStockAdjustmentTypes" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>

                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="AddStock_Remarks">{{ l('Remarks') }}</label>
                            <input type="text"
                                   id="AddStock_Remarks" class="form-control"
                                   [(ngModel)]="addStock.remarks" name="Remarks" />
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="5%">#</th>
                                    <th width="10%">{{ l('ItemCode') }}</th>
                                    <th width="30%">{{ l('ItemName') }}</th>
                                    <th width="8%">{{ l('Qty') }}</th>
                                    <th width="8%">{{ l('UOM') }}</th>
                                    <th width="8%">{{ l('Cost') }}</th>
                                    <th width="8%">{{ l('TotalCost') }}</th>
                                    <th width="8%">{{ l('Price') }}</th>
                                    <th width="8%">{{ l('TotalPrice') }}</th>
                                    <th width="5%">{{ l('Action') }}</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let data of addStockDetails; let i = index">
                                    <td class="text-center">
                                        <div class="d-flex align-items-center">
                                            <button class="btn btn-danger d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                    style="width: 30px; height: 30px" (click)="removeItem(i)">
                                                x
                                            </button>
                                            <span class="ps-1"><b>{{ data.slNo }}</b></span>
                                        </div>
                                        <!-- (click)="removeItem(i)" -->
                                    </td>
                                    <td> <input type="text" #itemCodeInput class="form-control" [(ngModel)]="data.productCode" (keydown.enter)="searchProduct(data.productCode,data,i)" (blur)="searchProduct(data.productCode,data,i)"  /> </td>
                                    <td>
                                        <app-search-product (productEvent)="getProduct($event,data,i)" [productSelectedItem]="data.productSelectedItem"> </app-search-product>
                                    </td>
                                    <td><input type="text" #qtyInput (keydown.enter)="focusNext('cost', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.qty" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td>
                                        <a *ngIf="!data.changeUnitFlag" (click)="changeUnit(data)"><span><b> {{data.unitName}} </b> </span> </a>
                                        <select name="data.unitId" *ngIf="data.changeUnitFlag"
                                                [(ngModel)]="data.unitId"
                                                class="form-select"
                                                required>
                                            
                                            <option *ngFor="let item of data.applicableUnits" value="{{ item.unitId }}">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td><input type="text" #costInput (keydown.enter)="focusNext('focQty', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.cost" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td class="text-end"><b>{{data.totalCost }}</b></td>
                                    <td><input type="text" #itemDiscountPercInput (keydown.enter)="focusNext('itemDiscount', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.price" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td class="text-end"><b>{{data.totalPrice }}</b></td>
                                    <td width="5%" class="text-center">
                                        <button  #addButton (keydown.enter)="focusNext('nextRow', i)" class="btn btn-success d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                style="width: 30px; height: 30px" (click)="addRow(i)" >
                                           +
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <table>
                            <tr>
                                <td width="80%" style="vertical-align: top">
                                    <div class="row" style="margin-right:8px;">
                                        <div class="col-md-8">&nbsp;&nbsp;</div>
                                        
                                    </div>
                                </td>
                                <td width="20%" style="vertical-align: top">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="AddStock_PSubTotal">{{ l('TotalQty') }}</label>
                                                <input type="number" readonly="readonly"
                                                       id="AddStock_PSubTotal" class="form-control text-end"
                                                       [(ngModel)]="addStock.stockQty" name="PSubTotal" />

                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="AddStock_PGrandTotal">{{ l('TotalCost') }}</label>
                                                <input type="number"
                                                       id="AddStock_PGrandTotal" class="form-control text-end"
                                                       [(ngModel)]="addStock.totalCost" name="PGrandTotal" readonly="readonly" />
                                            </div>
                                        </div> 
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="AddStock_PNetTotal">{{ l('TotalPrice') }}</label>
                                                <input type="number"
                                                       id="AddStock_PNetTotal" class="form-control text-end"
                                                       [(ngModel)]="addStock.totalPrice" name="PNetTotal" readonly="readonly" />

                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button (click)="save(status.Draft)" class="btn btn-primary blue me-2" [buttonBusy]="saving"
                            *ngIf="addStock.status == status.Draft"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAsDraft') }}</span>
                    </button>

                    <button (click)="save(status.Added)" *ngIf="addStock.id == null"
                            class="btn btn-primary blue float-right" [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }} {{addStock.id}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
